export default __webpack_public_path__ + "static/media/lavoro.3ace1173.jpg";